import cv from '../img/portImages/cv_css.png';
import bgi from '../img/portImages/banner2.jpg';
import bank from '../img/portImages/maya-3.jpg';
import pverse from '../img/portImages/pverse.jpg';
import ewaste from '../img/portImages/e-waste-recycling.jpg';
import corona from '../img/portImages/corona.png';
import per from '../img/portImages/per.jpg';
import react from '../img/portImages/react.jpg';
import reg from '../img/portImages/reg.jpg';
import rishu from '../img/portImages/rishu.jpg';
import san from '../img/portImages/san.jpg';
import weather from '../img/portImages/Weather.png';
import micropos from '../img/portImages/micropos.png';
import Virtual from '../img/portImages/Virtual.png';
import TourAll from '../img/portImages/TourAll.png';
import PortfolioImg from '../img/portImages/PortfolioImg.png';
import PatientImg from '../img/portImages/PatientImg.png';

const portfolios = [
     {
        id: 14,
        category: 'MERN',
        image: micropos,
        link1: 'https://microposindia.vercel.app/',
        link2: 'https://youtu.be/VkLkPdU3MT0',
        title: 'Micropos: A Multistore Billing Web App',
        text: 'Created with ReactJs, Node, Express, Postgres and more'
    },
       {
        id: 15,
        category: 'MERN',
        image: Virtual,
        link1: 'https://github.com/prabhukumarsaw',
        link2: 'https://youtu.be/VkLkPdU3MT0',
        title: 'Virtual Classroom Connect',
        text: 'Virtual Classroom Connect: An Online Education Platform Built with MERN Stack'
    },
       {
        id: 16,
        category: 'NEXTJS',
        image: TourAll,
        link1: 'https://tourall.vercel.app/',
        link2: 'https://youtu.be/VkLkPdU3MT0',
        title: 'TourAll',
        text: 'TourAll: An Online Cab Booking, Tour Plan, Sale & Buy Vehicals Platform Built with MERN Stack'
    },
         {
        id: 17,
        category: 'NEXTJS',
        image: PortfolioImg,
        link1: 'https://github.com/prabhukumarsaw/ankit-portfolio-test',
        link2: 'https://youtu.be/VkLkPdU3MT0',
        title: 'Responsive Portfolio',
        text: 'Responsive Portfolio showcase Built with MERN Stack'
    },
           {
        id: 16,
        category: 'NEXTJS',
        image: PatientImg,
        link1: 'https://patients-web-nine.vercel.app/',
        link2: 'https://youtu.be/VkLkPdU3MT0',
        title: 'HIMS Patient Appointment',
        text: 'HIMS: An HIMS Patient profile Platform Built with MERN Stack'
    },
    {
        id: 1,
        category: 'React',
        image: pverse,
        link1: 'https://prabhuverse.vercel.app/',
        link2: 'https://youtu.be/qL1en3gs5rk',
        title: 'PrabhuVerse Freelancing Project',
        text: 'Created with ReactJs and React Libraries'
    },
    {
        id: 2,
        category: 'PhP',
        image: bgi,
        link1: 'https://github.com/prabhukumarsaw/BCE-Mandideep-College-Website',
        link2: 'https://www.youtube.com/channel/UCgOxaOgWPLpWszxR0bL-nsA',
        title: 'BGI College Website',
        text: 'Created with PHP, CSS, JavaScript, AND MYSQL'
    },
    {
        id: 3,
        category: 'JavaScript',
        image: cv,
        link1: 'https://github.com/prabhukumarsaw/RESPONSIVE-CV-WEBPAGE-DESIGN',
        link2: 'https://www.youtube.com/channel/UCgOxaOgWPLpWszxR0bL-nsA',
        title: 'CV Making App',
        text: 'Created with PHP, CSS, JavaScript.'
    },
    {
        id: 4,
        category: 'PhP',
        image: react,
        link1: 'https://github.com/prabhukumarsaw/SG.github.io',
        link2: 'https://www.thesawraj.com',
        title: 'News App',
        text: 'Created with PHP, CSS, Material UI, JavaScript, AND MYSQL'
    },
   
    {
        id: 5,
        category: 'PhP',
        image: corona,
        link1: 'https://github.com/prabhukumarsaw',
        link2: 'https://www.youtube.com/channel/UCgOxaOgWPLpWszxR0bL-nsA',
        title: 'Corona API',
        text: 'Created with Javascript, Html, CSS'
    },
    {
        id: 6,
        category: 'PhP',
        image: ewaste,
        link1: 'https://github.com/prabhukumarsaw',
        link2: 'https://www.youtube.com/channel/UCgOxaOgWPLpWszxR0bL-nsA',
        title: 'E-Waste Management Project',
        text: 'Created with PHP, CSS, BootStrap, JavaScript, AND MYSQL'
    },
    {
        id: 7,
        category: 'PhP',
        image: react,
        link1: 'https://github.com/prabhukumarsaw',
        link2: 'https://www.youtube.com/channel/UCgOxaOgWPLpWszxR0bL-nsA',
        title: 'Blog Website',
        text: 'Created with PHP, CSS, Bootstap, JavaScript, AND MYSQL'
    },
    {
        id: 8,
        category: 'React',
        image: reg,
        link1: 'https://github.com/prabhukumarsaw',
        link2: 'https://www.youtube.com/channel/UCgOxaOgWPLpWszxR0bL-nsA',
        title: 'Responsive Registration APP',
        text: 'Created with ReactJs, Bootstrap, Node Js, Express Js, AND MongoDB'
    },
    {
        id: 9,
        category: 'React',
        image: per,
        link1: 'https://github.com/prabhukumarsaw',
        link2: 'https://www.youtube.com/channel/UCgOxaOgWPLpWszxR0bL-nsA',
        title: 'Responsive Portfolio',
        text: 'Created with ReactJs, Bootstrap, Node Js, Express Js, AND MongoDB'
    },
    {
        id: 10,
        category: 'React',
        image: rishu,
        link1: 'http://rishu4kstudio.000webhostapp.com/',
        link2: 'https://www.youtube.com/channel/UCgOxaOgWPLpWszxR0bL-nsA',
        title: 'MixingStudio Booking Mangement',
        text: 'Created with ReactJs, Bootstrap, Node Js, Express Js, AND MongoDB'
    },
    {
        id: 11,
        category: 'React',
        image: san,
        link1: 'http://santoshhdvideo.in/',
        link2: 'https://www.youtube.com/channel/UCgOxaOgWPLpWszxR0bL-nsA',
        title: 'E-Commerce Website',
        text: 'Created with ReactJs, Bootstrap, Node Js, Express Js, AND MongoDB'
    },
   
    {
        id: 12,
        category: 'React',
        image: weather,
        link1: 'https://github.com/prabhukumarsaw',
        link2: 'https://www.youtube.com/channel/UCgOxaOgWPLpWszxR0bL-nsA',
        title: 'Weather App',
        text: 'Created with ReactJs, Bootstrap, Node Js, Express Js, AND MongoDB'
    },
    {
        id: 13,
        category: 'PhP',
        image: bank,
        link1: 'https://github.com/prabhukumarsaw/Basic-Banking-System',
        link2: 'https://youtu.be/qL1en3gs5rk',
        title: 'Basic Bank System',
        text: 'Created with PHP, CSS, JavaScript, AND MYSQL'
    },
]

export default portfolios;
